import { FC } from 'react';

import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useFormContext } from 'react-hook-form-mui';
import { Button, Spinner } from 'view/components';
import { SearchAutocompleteField } from 'view/pages/profile/components';
import * as S from 'view/modals/OnboardingWizard/styled';

interface HiringNeedsStepProps {
  onBack: () => void;
  onComplete: () => void;
  isSubmitting: boolean;
}

const HiringNeedsStep: FC<HiringNeedsStepProps> = ({ onBack, onComplete, isSubmitting }) => {
  const { watch, setValue } = useFormContext();

  const recruiterTypeValue = watch('recruiterType') ?? 'representative';
  const companyValue = watch('company') ?? null;

  // Company is required only if representing a company
  const isValid =
    recruiterTypeValue === 'individual' ||
    (recruiterTypeValue === 'representative' && companyValue);

  return (
    <S.WizardContent>
      <S.StepHeader>
        <S.StepTitle>Tell Us About your Hiring Needs</S.StepTitle>
        <S.StepSubtitle>
          We&apos;ll use this information to personalize your experience and connect you with the
          right candidates
        </S.StepSubtitle>
      </S.StepHeader>
      <S.StepFormContainer>
        <RadioGroup
          value={recruiterTypeValue}
          onChange={(e) => {
            setValue('recruiterType', e.target.value);
          }}
        >
          <FormControlLabel
            value="representative"
            control={
              <Radio
                sx={{
                  '&.Mui-checked': { color: '#85C553' },
                }}
              />
            }
            label="I'm representing a company"
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '16px', fontWeight: 500 } }}
          />
          <FormControlLabel
            value="individual"
            control={
              <Radio
                sx={{
                  '&.Mui-checked': { color: '#85C553' },
                }}
              />
            }
            label="I'm Hiring independently"
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '16px', fontWeight: 500 } }}
          />
        </RadioGroup>

        {recruiterTypeValue === 'representative' && (
          <>
            <SearchAutocompleteField
              endpoint="/api/v1/companies/autocomplete"
              name="company"
              label="Company Name *"
              value={companyValue}
              setValue={setValue}
            />
          </>
        )}
      </S.StepFormContainer>
      <S.WizardFooter>
        <Button variant="outlined" text="Back" onClick={onBack} disabled={isSubmitting} />
        <Button
          variant="contained"
          text="Complete Profile"
          onClick={onComplete}
          disabled={!isValid || isSubmitting}
          endIcon={isSubmitting ? <Spinner disabled variant="contained" /> : null}
        />
      </S.WizardFooter>
    </S.WizardContent>
  );
};

export default HiringNeedsStep;
